import { gql } from "@apollo/client";

export const createLeaveRequest = gql`
 mutation RequestForLeave($input: LeaveRequestInput!) {
          addleaveApproval(input: $input) {
            leaveApproval {
              id
              user {
                username
              }
              teamleaderId
              leaveType {
                id
              }
              leaveFrom
              leaveTill
              reason
              primaryDor {
                username
              }
              secondaryDor {
                username
              }
              followUpTasks
              status
            }
          }
}`;


export const getLeaveBalanceOfUser = `
query LeaveBalanceByUser($userId: Int!) {
  leaveBalanceByUser(userId: $userId) {
  id
    leaveType
    balanceLeave
    id
    active
  }
}`;

export const editLeaveMutation = `
      mutation UpdateLeaveRequest($id: String!, $input: UpdateLeaveRequestInput!) {
    UpdateLeaveRequest(id: $id, input: $input) {
      success
      message
      error
      updateLeave {
        id
        user {
          id
          firstName
          lastName
        }
        leaveType {
          id
          name
        }
        leaveFrom
        leaveTill
        totalDays
        reason
        halfDay
        halfDayDuration
        primaryDor {
          id
          firstName
        }
        secondaryDor {
          id
          firstName
        }
        followUpTasks
        teamApproval
        requestedOn
      }
    }
  }`

export const deleteLeaveRequest =`
mutation delete($id:String!){
        DeleteLeaveRequest(id:$id){
          success
        }
}`;

export const LeaveDetailOptions = [
    { value: "sickLeave", label: "Sick Leave" },
    { value: "casualLeave", label: "Casual Leave" },
    { value: "earnedLeave", label: "Earned Leave" },
    { value: "restrictedLeave", label: "Restricted Leave" },
    { value: "lossofpay", label: "Loss Of Pay" },
];

export const getLeaveDataById = `
query GetLeaveById($id: String!) {
   
    getLeaveById(id: $id) {
   
      data {
   
        id
   
        reason
   
        totalDays 
        leaveFrom
        leaveTill
          halfDay
        halfDayDuration
        user{
          id
          firstName
          lastName
        }
        status
        teamApproval
        hrApproval
        teamleaderId
        leaveType{
          id
          name
        }
  
   
        primaryDor{
          id
          firstName
          lastName
   
        }
   
   
        secondaryDor{
          id
          firstName
          lastName
  
   
        } 
        attachment
        approvalStatus{
          id
          approver{
            id
            firstName
            lastName
          }
        }
   
   
        followUpTasks
   
      }
   
      success
   
      error
   
      message
   
    }
   
  }`;

export const getEmployeeDorDetailsQuery = `
     query GetEmployees($department: String!, $id: String!) {  
      getEmployeesByDepartment(department: $department, id: $id) {  
        id  
        username  
        firstName
        lastName
        department  
      }  
    } `;
